import React from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import PricingDefaultHeader from "./pricing/pricing-default/PricingDefaultHeader";
import PricingDefaultCard from "./pricing/pricing-default/PricingDefaultCard";
import useFakeFetch from "./hooks/useFakeFetch";
import { pricingData } from "./data/pricing";
import PageHeader from "./common/PageHeader";
// import Loader from "./common/Loader";
import PricingCalculator from "./PricingPageBasicDsn";
export default function Pricing() {
  const { loading: priceLoading, data: pricing } = useFakeFetch(
    pricingData,
    1000
  );

  return (
    <div className="container" style={{ marginTop: "80px" }}>
      <PageHeader
        // preTitle="Free for 30 days"
        title="CONDOZAK™ Pricing"
        description="We offer competitive pricing plans that are designed to fit the unique needs of your property management."
        className="mb-3"
        titleTag="h2"
      >
        <Link className="btn btn-sm btn-link ps-0" to="/contact-us">
          Have questions? Chat with us
        </Link>
      </PageHeader>
      <PricingCalculator />
      <br />
      
      {/* <Card className="mb-3">
        <Card.Body>
          <Row className="g-0">
            <PricingDefaultHeader />
            {priceLoading ? (
              <Col xs={12} className="py-4">
                <Spinner
                  className="position-absolute start-50"
                  animation="grow"
                />
              </Col>
            ) : (
              pricing.map((pricing) => (
                <PricingDefaultCard key={pricing.id} pricing={pricing} />
              ))
            )}
            <br />
            <Col xs={12} className="text-center">
              <h5 className="mt-5 mb-4" style={{ lineHeight: "40px" }}>
                Our pricing plans are transparent and easy to understand.
                <br /> We believe in being upfront about our pricing, so there
                are no hidden fees or surprises.{" "}
              </h5>
              
            </Col>
          </Row>
        </Card.Body>
      </Card> */}
    </div>
  );
}

// [
//   {
//     "name": "Condo Control",
//     "pricing_page": "https://www.condocontrol.com/pricing/"
//   },
//   {
//     "name": "Buildium",
//     "pricing_page": "https://www.buildium.com/pricing/"
//   },
//   {
//     "name": "AppFolio",
//     "pricing_page": "https://www.appfolio.com/pricing"
//   },
//   {
//     "name": "Yardi Breeze",
//     "pricing_page": "https://www.yardibreeze.com/pricing/"
//   },
//   {
//     "name": "ManageCasa",
//     "pricing_page": "https://www.managecasa.com/en/pricing/"
//   },
//   {
//     "name": "TenantCloud",
//     "pricing_page": "https://www.tenantcloud.com/pricing"
//   },
//   {
//     "name": "Propertyware",
//     "pricing_page": "https://www.propertyware.com/pricing/"
//   },
//   {
//     "name": "Easy HOA",
//     "pricing_page": "https://www.easyhoa.com/pricing/"
//   },
//   {
//     "name": "PayHOA",
//     "pricing_page": "https://www.payhoa.com/pricing/"
//   },
//   {
//     "name": "HOA Start",
//     "pricing_page": "https://www.hoastart.com/pricing/"
//   },
//   {
//     "name": "Innago",
//     "pricing_page": "https://www.innago.com/pricing/"
//   },
//   {
//     "name": "Condo Manager",
//     "pricing_page": "https://www.softwareadvice.com/property/condo-manager-property-management-profile/"
//   },
//   {
//     "name": "DoorLoop",
//     "pricing_page": "https://www.doorloop.com/pricing/"
//   },
//   {
//     "name": "Condominium Management Software",
//     "pricing_page": "https://www.condomanagementsoftware.com/Home/Pricing"
//   }
// ]
